import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { CreateloadService } from "../../../app/services/createload.service";
import { DeductionService } from "../../../app/services/deduction.service";
import { DriversService } from "../../../app/services/driver.service";
import { DropoffserviceService } from "../../../app/services/dropoffservice.service";
import { PickupserviceService } from "../../../app/services/pickupservice.service";
import { SetupDataService } from "../../../app/services/setupdata.service";
import { TrailerService } from "../../../app/services/trailers.service";
import { TrucksService } from "../../../app/services/trucks.service";
import { VendorService } from "../../../app/services/vendor.service";
import { VendorBillService } from "../../../app/services/vendorBills.service";
import { CarrierService } from "../../../app/services/carrier.service";
import { DispatcherService } from "../../../app/services/dispatcher.service";
import { DxDataGridComponent } from "devextreme-angular";
import { DecimalPipe } from "@angular/common";
import { LoadpopupComponent } from "../../../app/views/theme/expensemanagement/loadpopup/loadpopup.component";
import { MatDialog } from "@angular/material/dialog";
import { pick } from "underscore";

@Component({
  selector: 'app-loads-pay-popup-deductions-component',
  templateUrl: './loads-pay-popup-deductions-component.component.html',
  styleUrls: ['./loads-pay-popup-deductions-component.component.scss'],
  providers: [
    SetupDataService,
    VendorBillService,
    VendorService,
    DriversService,
    CarrierService,
    DispatcherService,
    TrucksService,
    CreateloadService,
    PickupserviceService,
    TrailerService,
  ],
})
export class LoadsPayPopupDeductionsComponentComponent implements OnInit {
  @Input() loadNumber: number;
  @Input() role: string;
  @Input() pickupInfo: any;
  @Output() newItemEvent = new EventEmitter<string>();
  @ViewChild(DxDataGridComponent, { static: false }) grid: DxDataGridComponent;
  pageFilters: any = {};
  drivers: any[] = [];
  driverList: any[] = [];
  driversConst: any[] = [];
  carriers: any[] = [];
  carriersConst: any[] = [];
  dispatchers: any[] = [];
  dispatchersConst: any[] = [];
  loads: any[];
  trucks: any[];
  trailers: any[];
  vendors: any[] = [];
  pickups: any[] = [];
  dropoffs: any[] = [];
  expenseDetails: any = {};
  expenseDetailsData: any[];
  IsDataloading: boolean = false;
  gridBoxValue: number[] = [2];
  totalBillAmount: number;
  driver1;
  truck;
  mode = true;
  paymentTerms = 0;
  isCustomTerms = false;
  selectedLoadId: string = "";
  paymentTermsList: any[] = [];
  loadingVisible = false;
  driverNameIdMap = {};
  carrierNameIdMap = {};
  dispatcherNameIdMap = {};
  isDriverInvalid = false;
  isCarrierInvalid = false;
  isDispatcherInvalid = false;
  newRowPosition = 'last';
  backupBillLines: string = '';
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private _toaster: ToastrService,
    private setupdataService: SetupDataService,
    private vendorService: VendorService,
    private _driverService: DriversService,
    private _trucksService: TrucksService,
    private _trailersService: TrailerService,
    private _loadsService: CreateloadService,
    private _pickupService: PickupserviceService,
    private _dropoffService: DropoffserviceService,
    private _deductionService: DeductionService,
    private _carrierService: CarrierService,
    private _dispatcherService: DispatcherService,
    private _deductionservice: DeductionService,
    private decimalPipe: DecimalPipe,
    public dialog: MatDialog,
  ) { }

  ngOnInit(): void {
    this.getData();
    this.vendorService.getVendorData().subscribe((data) => {
      this.vendors = data.result;
    });
    this.setupdataService.getBCExpenseTypes().subscribe((data) => {
      //(data);
      this.setupExpense();
      this.expenseDetails = data.result;
    });

    this._driverService.getDriversData().subscribe((data) => {
      for (let i = 0; i < data.result.length; i++) {
        const driver = data.result[i];
        if (driver.fullName != undefined) {
          this.drivers.push(driver);
          this.driversConst.push(driver);
          this.driverList.push(driver);
          this.driverNameIdMap[driver.fullName] = driver._id;
        }
      }
    });
    this._carrierService.getCarrierData().subscribe((data) => {
      for (let i = 0; i < data.result.length; i++) {
        const carrier = data.result[i];
        if (carrier.companyname != undefined) {
          this.carriers.push(carrier);
          this.carriersConst.push(carrier);
          this.carrierNameIdMap[carrier.companyname] = carrier._id;
        }
      }
    });
    this._dispatcherService.getDispatcherData().subscribe((data) => {
      for (let i = 0; i < data.result.length; i++) {
        const dispatcher = data.result[i];
        if (dispatcher.firstName != undefined) {
          this.dispatchers.push(dispatcher);
          this.dispatchersConst.push(dispatcher);
          this.dispatcherNameIdMap[dispatcher.firstName] = dispatcher._id;
        }
      }
    });

    this._trucksService.getTrucksData().subscribe((data) => {
      this.trucks = data.result;
    });
    this._trailersService.getTrailersData().subscribe((data) => {
      this.trailers = data.result;
    });

    this._loadsService.getLoadData().subscribe((data) => {
      this.loads = data.result;
    });

    this._pickupService.getpickupData().subscribe((data) => {
      this.pickups = data.result;
    });
    this._dropoffService.getdroppoffData().subscribe(async (data) => {
      this.dropoffs = data.result;
    });
    this.setupdataService.getBCPaymentTerms().subscribe((data) => {
      this.paymentTermsList = data.result;
    });
    this.setCellValue = this.setCellValue.bind(this);
    console.log(this.pageFilters.billLines);
  }
  getData(isSave?:boolean) {
    this.pageFilters = {};
    // console.log(this.pageFilters);
    // this.route.params.subscribe((param) => {
    //   this.role = param.role;
    // });
    this.pageFilters.paidAmount = 0;
    this.mode = false;
    this.pageFilters.billLines = [];
    this.pageFilters.billAmount = 0;
    this.totalBillAmount = 0;
    var date = new Date();
    var yyyy = date.getFullYear().toString();
    var mm = (date.getMonth() + 1).toString();
    var dd = date.getDate().toString();
    this.pageFilters.billDate =
      yyyy +
      "-" +
      (mm[1] ? mm : "0" + mm[0]) +
      "-" +
      (dd[1] ? dd : "0" + dd[0]);
    this.pageFilters.paymentterm = "";


    this._deductionservice.getDeductionData(this.role).subscribe((data) => {
     
      for (let i = 0; i < data.result.length; i++) {
        let deduction = data.result[i];
        deduction = deduction?.billLines?.filter((x:any)=>x.loadId?.loadNumber === this.loadNumber)
      
        for (let j = 0; j < deduction?.length; j++) {
          const deductionLine = deduction[j];
          console.log(deductionLine)
          let deductionObj = {
            billId: deduction.billId,
            loadNumber: deductionLine?.loadId?.loadNumber,
            loadId: deductionLine?.loadId?._id,
            driverId: deductionLine?.driverId?._id,
            truckId: deductionLine?.truckId,
            trailerId: deductionLine?.trailerId,
            billAmount: deductionLine.billAmount * -1,
            comment: deductionLine.comment,
            deliveryDate: deduction.dueDate,
            finalAmount: deductionLine.billAmount * -1,
            remainingAmount:
              (deductionLine.billAmount - deductionLine.paidAmount) * -1,
            paymentAmount: "",
            isEdited: false,
            isDeduction: true,
            expense: isSave===true? deductionLine.expenseType.ExpenseNo:deductionLine.expenseType,
            deductionId: deductionLine._id,
            driverName: deduction?.driverName,
            _id: deductionLine._id
          };
        
          // if (deductionLine?.remainingAmount > 0) {
          this.pageFilters.billLines.push(deductionObj);
          console.log(this.pageFilters.billLines)
          // }
        }
      }
      this.pageFilters.billAmount = this.calculateBillAmount(this.pageFilters.billLines)
    });
  }
  setupExpense() {
    this.pageFilters.billLines.forEach((e) => {
      e.expense = e.expense.ExpenseNo;
    });
  }
  setCellValue(rowData: any, value: any, currentRowData: any): void {
    const pickup = this.pickups.filter((p) => p.loadId?._id ? p.loadId._id == value : p.loadId == value);

    //   this.driver1 = data.result[0].driver1._id
    //   this.truck = data.result[0].truck._id
    // if (pickup.length > 0) {
    //   if (pickup[0].driver1) {
    //     rowData.driverId = pickup[0].driver1._id;
    //   }
    //   if (pickup[0].truck) {
    //     rowData.truckId = pickup[0].truck._id;
    //   }
    //   if (pickup[0].trailer) {
    //     rowData.trailerId = pickup[0].trailer._id;
    //   }
    //   rowData.loadId = value;
    // } else {
    // rowData.loadId = value;
    this.dataGrid.instance.cellValue(rowData, "loadId", value);
    this.dataGrid.instance.cellValue(rowData, "truckId", pickup[0].truck?._id);
    this.dataGrid.instance.cellValue(rowData, "driverId", pickup[0].driver1?._id);
    this.dataGrid.instance.cellValue(rowData, "trailerId", pickup[0].trailer?._id);
    // }
  }
  gridBox_displayExpr(item) {
    return item && item.ExpenseNo + " " + item.Name;
  }
  gridBox_displayLoadExpr(load) {
    return load && load.loadNumber;
  }
  gridBox_displayDriverExpr(driver) {
    return driver && driver.fullName;
  }
  gridBox_displayTruckExpr(truck) {
    return truck && truck.truckUnitNumber;
  }
  gridBox_displayTrailerExpr(trailer) {
    return trailer && trailer.unitNumber;
  }
  vendorSelect(event) {
    const vendorData = this.vendors.find(
      (vendor) => vendor._id === this.pageFilters.vendorId
    );
    this.paymentTerms = vendorData.paymentterm;
    this.pageFilters.paymentterm = vendorData.paymentterm;
    this.dueDateCalculate();
  }
  updateDueDate() {
    this.dueDateCalculate();
  }
  dueDateCalculate() {
    console.log(this.pageFilters.paymentterm);
    if (this.pageFilters.paymentterm == "custom") {
      this.isCustomTerms = false;
    } else if (this.pageFilters.paymentterm == "COD") {
      this.pageFilters.dueDate = this.pageFilters.billDate;
      this.isCustomTerms = false;
    } else {
      this.isCustomTerms = true;
      var tmpDate = new Date(this.pageFilters.billDate);
      const dueDate = this.addDaysToDate(
        tmpDate,
        Number(parseInt(this.pageFilters.paymentterm))
      );
      var yyyy1 = dueDate.getFullYear().toString();
      var mm1 = (dueDate.getMonth() + 1).toString();
      var dd1 = dueDate.getDate().toString();
      this.pageFilters.dueDate =
        yyyy1 +
        "-" +
        (mm1[1] ? mm1 : "0" + mm1[0]) +
        "-" +
        (dd1[1] ? dd1 : "0" + dd1[0]);
    }
  }
  paymentTermSelect(event) {
    this.paymentTerms = parseInt(this.pageFilters.paymentterm);
    this.dueDateCalculate();
  }
  addDaysToDate(date, days) {
    var res = new Date(date);
    res.setDate(res.getDate() + days);
    return res;
  }
  findExpense(id: string) {
    ////("done");
    let expense = this.expenseDetails.find((x) =>
    ////(x._id, id);
    {
      delete x["@odata.etag"];
      return x.ExpenseNo == id;
    }
    );
    ////(expense, "expense");
    return expense;
  }
  formatThousandSeperator(inputNumber) {
    return this.decimalPipe.transform(inputNumber, "1.2-2");
  }
  convertNumber(inputValue) {
    inputValue = inputValue.toString();
    return Number(inputValue.replaceAll(",", ""));
  }
  onDriverSelected(value) {
    this.pageFilters.driverId = this.driverNameIdMap[value];
  }
  onDriverChange(value: string) {
    if (value != "" && value != undefined) {
      const filterValue = value.toLowerCase().replace(/[\W_]/g, "");
      this.drivers = this.driversConst.filter((option) =>
        option.fullName.toLowerCase().replace(/[\W_]/g, "").includes(filterValue)
      );
      const driverId = this.driverNameIdMap[value];
      let selectedDriver = this.driversConst.filter(
        (alias) => alias._id === driverId
      );
      if (selectedDriver.length > 0) {
        this.isDriverInvalid = false;
        this.onDriverSelected(value);
      } else {
        this.isDriverInvalid = true;
      }
    } else {
      this.isDriverInvalid = true;
      this.pageFilters.driverName = "";
      this.drivers = this.driversConst;
    }
  }
  onCarrierSelected(value) {
    this.pageFilters.carrierId = this.carrierNameIdMap[value];
  }
  onCarrierChange(value: string) {
    if (value != "" && value != undefined) {
      const filterValue = value.toLowerCase().replace(/[\W_]/g, "");
      this.carriers = this.carriersConst.filter((option) =>
        option.companyname.toLowerCase().replace(/[\W_]/g, "").includes(filterValue)
      );
      const carrierId = this.carrierNameIdMap[value];
      let selectedCarrier = this.carriersConst.filter(
        (alias) => alias._id === carrierId
      );
      if (selectedCarrier.length > 0) {
        this.isCarrierInvalid = false;
        this.onCarrierSelected(value);
      } else {
        this.isCarrierInvalid = true;
      }
    } else {
      this.isCarrierInvalid = true;
      this.pageFilters.carrierName = "";
      this.carriers = this.carriersConst;
    }
  }
  onDispatcherSelected(value) {
    this.pageFilters.dispatcherId = this.dispatcherNameIdMap[value];
  }
  onDispatcherChange(value: string) {
    if (value != "" && value != undefined) {
      const filterValue = value.toLowerCase().replace(/[\W_]/g, "");
      this.dispatchers = this.dispatchersConst.filter((option) =>
        option.firstName.toLowerCase().replace(/[\W_]/g, "").includes(filterValue)
      );
      const dispatcherId = this.dispatcherNameIdMap[value];
      let selectedDispatcher = this.dispatchersConst.filter(
        (alias) => alias._id === dispatcherId
      );
      if (selectedDispatcher.length > 0) {
        this.isDispatcherInvalid = false;
        this.onDispatcherSelected(value);
      } else {
        this.isDispatcherInvalid = true;
      }
    } else {
      this.isDispatcherInvalid = true;
      this.pageFilters.dispatcherName = "";
      this.dispatchers = this.dispatchersConst;
    }
  }
  reset() { }

  @ViewChild(DxDataGridComponent, { static: true })
  dataGrid: DxDataGridComponent;
  dmoOnChange(e) {
    let gridInstance = this.dataGrid.instance;
    var validationResults = [];
    // var newData = e.newData;

    let rows = gridInstance.getVisibleRows();
    let rowIndex = gridInstance.getRowIndexByKey(e.key);
    let row = rows[rowIndex];
    var newData = row.data;

    var expenseTypeValue = gridInstance.cellValue(rowIndex, "expense");
    let expenseTypeRecord = this.expenseDetails.filter(
      (e) => JSON.stringify(e.ExpenseNo) == JSON.stringify(expenseTypeValue)
    );

    console.log("Expense Name: ", expenseTypeRecord[0].ExpenseCategory, e);
    if (expenseTypeRecord[0].ExpenseCategory == "Load") {
      if (!newData.loadId) {
        validationResults.push("Load");
      }
      if (!newData.truckId) {
        validationResults.push("Truck");
      }
      if (!newData.driverId) {
        validationResults.push("Driver");
      }
    } else if (expenseTypeRecord[0].ExpenseCategory == "Truck") {
      if (!newData.truckId) {
        validationResults.push("Truck");
      }
      if (!newData.driverId) {
        validationResults.push("Driver");
      }
    } else if (expenseTypeRecord[0].ExpenseCategory == "Trailer") {
      if (!newData.trailerId) {
        validationResults.push("Trailer");
      }
    } else if (expenseTypeRecord[0].ExpenseCategory == "HR") {
    } else if (expenseTypeRecord[0].ExpenseCategory == "Overhead") {
    } else if (expenseTypeRecord[0].ExpenseCategory == "Capital Expense") {
      if (!newData.truckId || !newData.trailerId) {
        validationResults.push("Truck/Trailer");
      }
    }

    var validationMessage = validationResults.join(", ") + " is required";
    console.log("Validation Message:", validationMessage);

    var loadDxElement = gridInstance.byKey(row["cells"][1].key);
    console.log("Load Elem: ", loadDxElement);

    if (validationResults.length > 0) {
      e.errorText = validationMessage;
      e.isValid = false;
    }
  }

  calculateBillAmount(data:any){
    let total=0;
    for(let i=0;i<data.length;i++){
      total = total + data[i].billAmount;
    }
    return total*-1;
  }

  onSavedRow(event: any) {
    /* let eventAmount = event.data.billAmount;
    this.pageFilters.billAmount = this.formatThousandSeperator(Number(this.convertNumber(this.pageFilters.billAmount)) + Number(eventAmount));
    this.totalBillAmount =
      this.totalBillAmount + parseFloat(eventAmount.toFixed(3));
    this.totalBillAmount = parseFloat(this.totalBillAmount.toFixed(3)); */
    const sum = this.pageFilters.billLines.reduce((accumulator, object) => {
      return accumulator +  Math.abs(object.billAmount);
    }, 0);
    this.pageFilters.billAmount = this.formatThousandSeperator(sum);
  }
  onUpdatedRow(event: any) {
    const sum = this.pageFilters.billLines.reduce((accumulator, object) => {
      return accumulator + Math.abs(object.billAmount);
    }, 0);
    this.pageFilters.billAmount = this.formatThousandSeperator(sum);
  }
  onRowRemoved(event: any) {
    const sum = this.pageFilters.billLines.reduce((accumulator, object) => {
      return accumulator +  Math.abs(object.billAmount);
    }, 0);
    this.pageFilters.billAmount = this.formatThousandSeperator(sum);
  }
  submit(vendorBillForm) {
    this.grid.instance.saveEditData();
    console.log(vendorBillForm)
    if (vendorBillForm.valid) {
      vendorBillForm.submitted = true;
      this.pageFilters.billLines.forEach((x) => {
        delete x.billId;
        delete x.loadNumber;
        delete x.finalAmount;
        delete x.paymentAmount;
        delete x.isEdited;
        delete x.isDeduction;
        delete x.deductionId;
        delete x.driverName;
        delete x.deliveryDate;
        // delete x._id;
      });
      this.pageFilters.role = this.role;
      if(this.role === 'driver'){
        this.pageFilters.driverId = this.pickupInfo?.driver1?._id || this.pickupInfo?.driver2?._id;
        this.pageFilters.driverName = this.pickupInfo?.driver1?.fullName || this.pickupInfo?.driver2?.fullName;
      }
      if(this.role === 'carrier'){
        this.pageFilters.carrierId = this.pickupInfo?.carrier?._id;
        this.pageFilters.carrierName = this.pickupInfo?.carrier?.companyname;
      }
      console.log(this.pageFilters);
      if (this.pageFilters.billLines.length == 0) {
        this._toaster.error(
          "Please Enter an Deduction Line Item",
          "Validation Error",
          { timeOut: 5000 }
        );

        return;
      }
      const sum = this.pageFilters.billLines.reduce((accumulator, object) => {
        return accumulator + Math.abs(object.billAmount);
      }, 0);
      if (
        Number(this.convertNumber(this.pageFilters.billAmount)) !== Number(sum.toFixed(2))
      ) {
        this._toaster.error(
          "Balance and total payment amount did not match",
          "Validation Error",
          { timeOut: 5000 }
        );

        return;
      }
      this.pageFilters.remainingAmount = this.totalBillAmount;
      let expenses = this.pageFilters.billLines;
      this.backupBillLines = JSON.stringify(expenses);
      expenses.forEach((x) => {
        x.expenseType = this.findExpense(x.expense);
        delete x.__KEY__;
      });
      this.pageFilters.billLines = expenses;
      this.pageFilters.billAmount = Number(
        this.convertNumber(this.pageFilters.billAmount)
      );
      this.pageFilters.billLines.forEach((x) => {
        x["remainingAmount"] = x["billAmount"];
        delete x["_id"];
        delete x["@odata.etag"];
        delete x["expense"];
      });
      this._deductionService.SendForm(this.pageFilters).subscribe(
        (result) => {
          vendorBillForm.reset()
          vendorBillForm.submitted = false;
          this._toaster.info(
            "Successfully added the new deduction",
            "Success",
            {
              timeOut: 5000,
            }
          );
          this.getData(true);
          this.newItemEvent.emit();
          // switch (this.role) {
          //   case "driver":
          //     this.router.navigateByUrl("/loadpay/driver-payment");
          //     break;
          //   case "carrier":
          //     this.router.navigateByUrl("/loadpay/carrier-payment");
          //     break;
          //   case "dispatcher":
          //     this.router.navigateByUrl("/loadpay/dispatcher-payment");
          //     break;

          //   default:
          //     break;
          // }
        },
        (error) => {
          console.log(error);
          this.pageFilters.billLines = JSON.parse(this.backupBillLines);
          let resError = JSON.parse(error._body);
          this._toaster.error(resError.error.message, "Failed", {
            timeOut: 5000,
          });
        }
      );
    } else {
      this._toaster.error("Please fill all required filed", "Failed", {
        timeOut: 5000,
      });
    }
  }

  addRow() {
    this.grid.instance.addRow();
    this.grid.instance.deselectAll();
  }
  onCellClick(event) {
    if (event.columnIndex == 1 && event.rowType == "data") {
      let loads = this.loads.filter((x:any)=>x.loadNumber===this.loadNumber)
      console.log(this.loads)
      let dialogConfig = Object.assign(
        { width: "1100px" },
        {
          data: {
            pickupData: this.pickups,
            loadData: loads,
            dropoffData: this.dropoffs,
            loadId: event.data.load,
          },
        }
      );
      let editDialogRef = this.dialog.open(LoadpopupComponent, dialogConfig);
      editDialogRef.afterClosed().subscribe((data) => {
        // this.dataGrid.instance.cellValue(event.rowIndex, "load", data);
        if (data) {
          this.setCellValue(event.rowIndex, data, null);
        }
      });
    }
  }
  // setCellValue(rowIndex: any, value: any): void {
  //   var pickup = this.pickups.filter((p) => p.loadId?._id == value);
  //   /* rowData.driverId = pickup[0].driver1._id;
  //   rowData.truckId = pickup[0].truck._id;
  //   rowData.loadId = value; */
  //   this.dataGrid.instance.cellValue(rowIndex, "load", value);
  //   this.dataGrid.instance.cellValue(rowIndex, "truck", pickup[0].truck._id);
  //   this.dataGrid.instance.cellValue(rowIndex, "driver", pickup[0].driver1._id);
  // }
  onSelectedRole(event) {
    this.role = event.target.value;
    console.log(this.role)
    this.getData(true)
  }
}
